import { badge, primary, secondary, green, red, white } from '../styles';
import { badge as badgeCitrus2022, badgeDark as badgeCitrus2022Dark, primary as primaryCitrus2022, secondary as secondaryCitrus2022, green as greenCitrus2022, red as redCitrus2022, white as whiteCitrus2022, } from '../styles/citrus2022';
import { citrusStyled } from '@citrus/runtime';
export var Badge = citrusStyled.div('badge', {
    legacy: badge,
    citrus2022: badgeCitrus2022,
    citrus2022Dark: badgeCitrus2022Dark,
});
export var PrimaryBadge = citrusStyled.div('primary', { legacy: primary, citrus2022: primaryCitrus2022 });
export var SecondaryBadge = citrusStyled.div('secondary', { legacy: secondary, citrus2022: secondaryCitrus2022 });
export var GreenBadge = citrusStyled.div('green', { legacy: green, citrus2022: greenCitrus2022 });
export var RedBadge = citrusStyled.div('red', { legacy: red, citrus2022: redCitrus2022 });
export var WhiteBadge = citrusStyled.div('white', { legacy: white, citrus2022: whiteCitrus2022 });
export var Styled = {
    Badge: Badge,
    PrimaryBadge: PrimaryBadge,
    SecondaryBadge: SecondaryBadge,
    GreenBadge: GreenBadge,
    RedBadge: RedBadge,
    WhiteBadge: WhiteBadge,
};
